import { EventPresenterProps } from "@kaltura/mediaspace-shared-event-platform-event-list";
import { StyledPresenter, StyledPresenterContainer } from "./StyledComponents";
import { Link } from "@kaltura/ds-react-components";

export interface PresenterProps extends EventPresenterProps {
    isTranslucent?: boolean;
    showLink?: boolean;
    /**
     * for a11y roles
     */
    inGrid?: boolean;
}

/**
 * single Presenter used in media page
 */
export function Presenter(props: PresenterProps) {
    const { data, inGrid, showLink = true } = props;

    return (
        <StyledPresenterContainer role={inGrid ? "row" : undefined}>
            <div role={inGrid ? "gridcell" : undefined}>
                {showLink && (
                    <Link href={data.link}>
                        <StyledPresenter {...props} size={"large"} />
                    </Link>
                )}
                {!showLink && <StyledPresenter {...props} size={"large"} />}
            </div>
        </StyledPresenterContainer>
    );
}

export default Presenter;
